import React from "react";
import "antd/dist/antd.less";
import './App.less';

import Routing from "./Routes";
const  App= () => {
  return <Routing />
}
export default App;
